import { Component, Prop, h, State, Event, EventEmitter } from '@stencil/core';
import { ButtonState, ButtonSize } from './types';

@Component({
  tag: 'vsr-text-link-v2',
  styleUrl: 'vsr-button.scss',
  shadow: true,
})
export class VsrTextLink {
  @Prop() state: ButtonState = 'active';
  @Prop() size: ButtonSize = 'M';
  @Prop() href: string = '#';
  @Prop() focused: boolean = false;

  @State() isFocused: boolean = false;

  @Event() vsrClick: EventEmitter<MouseEvent>;

  componentWillLoad() {
    this.isFocused = this.focused;
  }

  private handleClick = (event: MouseEvent) => {
    this.vsrClick.emit(event);
  };

  render() {
    const linkClass = `text-link ${this.state.toLowerCase()} ${this.size} ${this.isFocused ? 'focused' : ''}`;

    return (
      <a
        class={linkClass}
        href={this.href}
        onClick={this.handleClick}
        onFocus={() => (this.isFocused = true)}
        onBlur={() => (this.isFocused = false)}
        aria-disabled={this.state === 'inactive'}
      >
        <span class="link-text">
          <slot>Link text</slot>
        </span>
        <span class="arrow-icon">→</span>
        {this.isFocused && <div class="focus-ring"></div>}
      </a>
    );
  }
}
